import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';

import { TitleContainer, TitleCopy } from './styles';

const title = {
  renderNode: {
    [BLOCKS.HEADING_3]: (_, children) => <TitleCopy>{children}</TitleCopy>,
  },
};

const TitleCard = ({ data }) => {
  if (!data) return null;

  const { heading, headingColor } = data;

  return (
    <TitleContainer headingColor={headingColor}>
      <RichText document={heading} options={title} />
    </TitleContainer>
  );
};

TitleCard.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default TitleCard;
